<template>
  <v-tooltip bottom>
    <template #activator="{ on, attrs }">
      <v-btn
        v-if="!$route.meta.hideClara && claraDisponivel"
        icon
        class="clara-launcher"
        :class="{ 'clara-launcher--on': isOpen }"
        data-test="btn-ai-assistant"
        :aria-label="isOpen ? 'Fechar a Clara' : 'Abrir a Clara'"
        :aria-pressed="String(isOpen)"
        v-bind="attrs"
        v-on="on"
        @click="toggle"
      >
        <PhSparkle
          :size="18"
          :weight="isOpen ? 'fill' : 'regular'"
        />
      </v-btn>
    </template>
    <span>{{ isOpen ? 'Fechar a Clara' : 'Clara AI · assistente' }}</span>
  </v-tooltip>
</template>

<script>
import { OPTIONS_STORE_CLARA } from '@/vuex/module/clara';
import { claraDisponivelPara } from '@/views/clara/claraAccess';

export default {
  name: 'ClaraLauncher',

  /* Padrao para a montagem isolada dos testes, que nao tem o App por cima. */
  inject: {
    appData: { default: () => ({}) }
  },

  computed: {
    claraDisponivel() {
      return claraDisponivelPara(this.appData.currentUser);
    },

    isOpen() {
      return this.$store.getters[OPTIONS_STORE_CLARA.GETTERS.IS_OPEN];
    }
  },

  methods: {
    toggle() {
      this.$store.commit(OPTIONS_STORE_CLARA.MUTATIONS.TOGGLE);
    }
  }
};
</script>

<style scoped>
/*
  O brilho é `box-shadow`, não um <span> posicionado.
  A primeira versão usava um filho com `position:absolute; inset:4px`, que
  dentro do botão flex do Vuetify resolvia para 28×10px em vez de 28×28 — saía
  uma barra azul torta atrás do ícone. box-shadow acompanha a caixa do botão
  sozinho, sem depender de contexto de posicionamento.
*/
/*
  Cor e anel ficam aqui; o PREENCHIMENTO fica no Menu.vue, junto da regra
  `.v-btn--icon { background: transparent }` que competia com ele — na mesma
  camada não há disputa de cascata.

  Os seletores encadeiam `.v-btn.v-btn--icon` porque o header estiliza os ícones
  por escopo e um `.clara-launcher` sozinho perde em especificidade.
*/
.clara-launcher.v-btn.v-btn--icon {
  color: var(--clara-text) !important;
  transition: background-color var(--tc-transition), box-shadow var(--tc-transition);
}

/* Aberto o botão é ESTADO, não convite: ganha o anel e para de pulsar. */
.clara-launcher--on.v-btn.v-btn--icon {
  box-shadow: inset 0 0 0 1px var(--clara-brand) !important;
}

/* Fechado, respira devagar. Um ciclo de 3,2s tem presença sem competir com a
   leitura da tela. */
.clara-launcher.v-btn:not(.clara-launcher--on) {
  animation: clara-respirar 3.2s ease-in-out infinite;
}

@keyframes clara-respirar {
  0%,
  100% {
    box-shadow: 0 0 0 0 transparent;
  }
  50% {
    box-shadow: 0 0 0 3px var(--clara-tint);
  }
}

@media (prefers-reduced-motion: reduce) {
  .clara-launcher.v-btn:not(.clara-launcher--on) {
    animation: none;
  }
}
</style>
